"use strict";
// (C) 2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdminInformationMessageState = exports.useLocalStorage = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var sdk_model_1 = require("@gooddata/sdk-model");
var util_1 = require("@gooddata/util");
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var LOCAL_STORAGE_KEY_PREFIX = "gdc_share_dialog_admin_message_visible_";
var createLocalStorageKey = function (currentUserRef) {
    return LOCAL_STORAGE_KEY_PREFIX + util_1.stringUtils.simplifyText(sdk_model_1.objRefToString(currentUserRef));
};
var getLocalStorageValue = function (key, defaultValue) {
    var item = localStorage.getItem(key);
    var value = JSON.parse(item);
    return isNil_1.default(value) ? defaultValue : value;
};
exports.useLocalStorage = function (key, defaultValue) {
    var _a = tslib_1.__read(react_1.useState(function () { return getLocalStorageValue(key, defaultValue); }), 2), value = _a[0], setValue = _a[1];
    react_1.useEffect(function () {
        localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);
    return [value, setValue];
};
exports.useAdminInformationMessageState = function (currentUserRef) {
    var localStorageKey = react_1.useMemo(function () { return createLocalStorageKey(currentUserRef); }, [currentUserRef]);
    var _a = tslib_1.__read(exports.useLocalStorage(localStorageKey, true), 2), isMessageVisible = _a[0], setIsMessageVisible = _a[1];
    var handleMessageClose = function () { return setIsMessageVisible(false); };
    return {
        isMessageVisible: isMessageVisible,
        handleMessageClose: handleMessageClose,
    };
};
//# sourceMappingURL=useAdminInformationMessage.js.map